module.exports = __webpack_public_path__ + "img/google_play.da6a1b70.svg";